// extracted by mini-css-extract-plugin
export default {"btn":"SwiperNavBtn_btn__WJgUy","btnDisabled":"SwiperNavBtn_btnDisabled__AYirs","btnActive":"SwiperNavBtn_btnActive__rgBCm","swiper_nav_btns":"SwiperNavBtn_swiper_nav_btns__HD98y"};